import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Paper,
  Card,
  CardContent,
} from '@material-ui/core';
import ContentLoader from 'react-content-loader';

import styles from './styles';

const getCard = (classes, id) => (
  <Card classes={{ root: classes.card }} key={id}>
    <CardContent
      classes={{ root: classes.cardContent }}
    >
      <ContentLoader height={100} width={250}>
        <rect x="0" y="20" rx="3" ry="3" width="150" height="10" />
        <rect x="0" y="40" rx="3" ry="3" width="220" height="10" />

        <rect x="0" y="60" rx="3" ry="3" width="70" height="10" />
        <rect x="0" y="80" rx="3" ry="3" width="90" height="10" />
      </ContentLoader>
      <ContentLoader height={100} width={250}>
        <rect x="0" y="20" rx="3" ry="3" width="150" height="10" />
        <rect x="0" y="40" rx="3" ry="3" width="220" height="10" />

        <rect x="0" y="60" rx="3" ry="3" width="70" height="10" />
        <rect x="0" y="80" rx="3" ry="3" width="90" height="10" />
      </ContentLoader>
    </CardContent>
  </Card>
);

const getKanbanColumn = (classes, numCards) => (
  <div className={classes.statusColumn}>
    <Paper className={classes.statusHeaderContainer}>
      <ContentLoader height={60}>
        <circle rx="0" ry="0" cx="30" cy="30" r="30" height="60" />
        <rect x="80" y="20" rx="5" ry="5" width="220" height="20" />
      </ContentLoader>
    </Paper>
    {numCards.map((val, index) => getCard(classes, index))}
  </div>
);

class EventKanbanContentLoaderComponent extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.statusContainer} style={{ width: (4 * (316)) }}>
        {getKanbanColumn(classes, [1, 1, 1])}
        {getKanbanColumn(classes, [1])}
        {getKanbanColumn(classes, [1, 1])}
        {getKanbanColumn(classes, [])}
      </div>
    );
  }
}

EventKanbanContentLoaderComponent.propTypes = { classes: PropTypes.object };

EventKanbanContentLoaderComponent.defaultProps = { classes: {} };

export default withStyles(styles)(EventKanbanContentLoaderComponent);
